import React from 'react'
import Grid from '@mui/material/Grid'
import styles from './Body-marketing.module.css'

import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grow from '@mui/material/Grow';

const marketingSection = {
  'Photography Request Form': {
    href: 'https://forms.office.com/r/tRWNfNdZ2r',
    img: require('../../../../assets/photography.png'),
    p: "Photography Request Form"
  },
  'Content and Event Promotion Form': {
    href: 'https://forms.office.com/Pages/ResponsePage.aspx?id=bSl5yj94AEmWHqscc8qGji5WJWhQg1BHgn9jX1zKD1BUNU8wQklZVFdGSlREQkxGTU5XNUNYNUw2VSQlQCN0PWcu',
    img: require('../../../../assets/content-event-promotion.png'),
    p: "Content and Event Promotion"
  },
  'Creative Request Form': {
    href: 'https://forms.office.com/r/v53Cyz5ST1',
    img: require('../../../../assets/creativerequest.png'),
    p: "Creative Request Form"
  },
  'Website Request Form': {
    href: 'https://forms.office.com/r/31MrgYaVAw',
    img: require('../../../../assets/content-event-promotion.png'),
    p: "Website Request Form"
  },
}

const generateCards = (sectionObj) => {
  /*
    <p>
                                  {sectionObj[siteName].p}
                                </p>
  */
    return Object.keys(sectionObj).map((siteName) => {
        return (
        <Grid key={siteName} item xs={12} sm={12} md={12} lg={4} className={styles.cardsContainer}>
            <Grow direction="up" in={true} timeout={{enter: 900, exit: 0}}>
                <Card className={styles.card} >
                    <CardActionArea target='_blank' rel='noopener noreferrer' href={sectionObj[siteName].href}>
                        <div className={styles.cardLayout}>
                            <CardMedia
                              component="img"
                              alt={siteName}
                              className={styles.media}
                              //height="220"
                              src={sectionObj[siteName].img}
                              title={siteName}
                              />
                              <div className={styles.cardContent}> 
                                <h4 className={styles.linkLabel}>{siteName}</h4>
                              </div>
                        </div>
                    </CardActionArea>
                </Card>
             </Grow>
        </Grid>
        )
    })
}

const Body = () => {
  return (
  <Grid container className={styles.bodyContainer}>
    <Grid item xs={12} sm={12} md={12}>
      <h1 style={{textAlign: "center"}}>University Marketing & Communications Support Requests</h1>
        <hr style={{width: '80%'}}/>
      <Grid container justify="center">
        {generateCards(marketingSection)}
      </Grid>
    </Grid>
  </Grid>
  )
}

export default Body